import { Field } from '@/client/schema'

export const _getFormFieldName = (field: Field) => {
    if (field.type === 'Ref' && field.__kind === 'RefEnum') {
        return field.__key || field.__ref.__key
    }
    return field.__key
}
